export const isValidReturnUrl = (url) => {
  try {
    if (!url.startsWith('/') || url.startsWith('//')) {
      return false;
    }

    const allowedPaths = [
      '/dashboard',
      '/v2/upcoming-event',
      '/v2/upcoming-events',
      '/v2/finances',
      '/v2/event-drafts',
      '/referral',
      '/v2/create-event/type',
    ];

    return allowedPaths.some(path => url.startsWith(path));
  } catch {
    return false;
  }
};

// GO4-1833 — /new-password and /confirmation each took a URL straight off the
// query string and dropped it into an anchor's href. A "javascript:" value
// survives that, so a crafted link ran script in the Go4 origin the moment the
// victim clicked the button: enough to drive the password-reset context the
// page itself carries, or to read the signed-in user's profile.
//
// Every legitimate value is one of three shapes — a relative app path, an https
// URL on a Go4 host, or the mobile app's own scheme — so validate against those
// rather than trying to blocklist dangerous schemes.
const APP_SCHEME = 'go4ellis:';
const ALLOWED_HOST = 'go4.io';

// Browsers ignore control characters inside a URL, so a scheme split by a tab
// navigates just like the unsplit one. Strip them before parsing, or the check
// runs against a string the browser will never see.
// eslint-disable-next-line no-control-regex -- matching them is the point
const CONTROL_CHARS = /[\u0000-\u001F\u007F]/g;

// Rejects "//evil.com" and "/\evil.com", which a browser reads as
// protocol-relative URLs rather than as paths.
const SAFE_RELATIVE_PATH = /^\/([^/\\]|$)/;

export const sanitizeLinkUrl = (value, fallback = null) => {
  if (typeof value !== 'string') return fallback;

  const url = value.replace(CONTROL_CHARS, '').trim();
  if (!url) return fallback;

  if (url.startsWith('/')) {
    return SAFE_RELATIVE_PATH.test(url) ? url : fallback;
  }

  let parsed;
  try {
    parsed = new URL(url);
  } catch {
    return fallback;
  }

  if (parsed.protocol === APP_SCHEME) return url;
  if (parsed.protocol !== 'https:') return fallback;

  const host = parsed.hostname.toLowerCase();
  return host === ALLOWED_HOST || host.endsWith(`.${ALLOWED_HOST}`) ? url : fallback;
};
